import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative bg-[#FDF6F0] pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-85">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#E8F0E8] rounded-full mix-blend-multiply filter blur-3xl opacity-70 -translate-x-1/2 -translate-y-1/2" data-id="element-86"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C97B63] rounded-full mix-blend-multiply filter blur-3xl opacity-10 translate-x-1/3 translate-y-1/3" data-id="element-87"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-88">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-89">
          <FadeIn data-id="element-90">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#1A5C4C] leading-tight mb-6" data-id="element-91">
              El "Muro de los 45" ha caído: Cómo reactivar tu metabolismo
              estancado en solo 21 días{' '}
              <span className="text-[#C97B63] italic" data-id="element-92">(Sin pasar hambre)</span>
            </h1>
            <p className="text-lg md:text-xl text-[#2A2A2A] mb-8 leading-relaxed" data-id="element-93">
              El protocolo de Ciclado Hormonal diseñado específicamente para la
              mujer latina en EE.UU. que lucha contra la grasa abdominal y el
              cansancio crónico.
            </p>
            <Button className="w-full md:w-auto" onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-94">
              ¡Quiero mi reset metabólico ahora!
            </Button>
            <p className="mt-4 text-sm text-[#2A2A2A] opacity-70 flex items-center justify-center md:justify-start" data-id="element-95">
              <span className="mr-2" data-id="element-96">🔒</span> Pago seguro y cifrado. Acceso
              inmediato.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} className="relative" data-id="element-97">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/82eHBPEEvGavwdEKehMnt7/heylloyd-image-1773194508295_PROD_METABOLISMO.png" alt="Metabolismo 45+ Reset eBook" className="w-full h-auto object-cover" data-id="element-99" />
            </div>
            {/* Decorative leaf-like shape */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#1A5C4C] rounded-tl-full rounded-br-full opacity-20 -z-10" data-id="element-100"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}